import Vue from 'vue'
import Router from 'vue-router'
import NavBar from '@/components/NavBar.vue'
import detail from "./detail"; // 详情页面

Vue.use(Router)
/**
 * 全屏页面
 */
const other = [

]
/**
 * 导航页面
 */
const Main = [
  {
    path: '/', redirect: '/homepage', name: 'homepage', meta: { title: '首页' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/homepage', name: 'homepage-index', component: () => import('@/ivews/homepage/index.vue'), hidden: false, meta: { title: '首页' } },
    ]
  },
  {
    path: '/aboutUsUs', redirect: '/aboutUsUs', name: 'aboutUsUs', meta: { title: '关于南软' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/aboutUsUs', name: 'aboutUsUs', component: () => import('@/ivews/aboutUsUs/AboutUsUs.vue'), hidden: false, meta: { title: '关于南软' } },
    ]
  }
]

export default new Router({
  routes: [
    // ...other,
    ...Main  
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js